import { ProviderRowActions } from 'modules/inventory/provider/supplier/components/ProviderRowActions';
import { CellAlign, HeadCell } from '@dfl/mui-admin-layout';
import { addressColumn, createdATColumn } from 'modules/common/constants/common.columns';
import { SUPPLIER_PERMISSIONS } from 'modules/inventory/provider/supplier/constants/supplier.permissions';
import {
  providerEmailColumn,
  providerPhoneColumn,
  providerImageColumn,
} from 'modules/inventory/provider/common/constants';
import { IProvider } from 'modules/inventory/provider/common/interfaces';
import { PercentValue } from 'components/libs/PercentValue';
import { AvatarNameCell } from 'modules/common/components/AvatarNameCell';
import { ProviderStatePicker } from '../../common/components';
import { Typography } from '@mui/material';
import { IAddress } from 'lib/dfl-address-form-mui/interfaces';

export const providerCommissionColumn: HeadCell<IProvider> = {
  field: 'commission',
  align: CellAlign.CENTER,
  headerName: 'supplier:fields.commission',
  renderCell: (commission: number) => <PercentValue value={commission || 0} />,
};

export const providersActionsColumn: HeadCell<IProvider> = {
  field: 'actions',
  sortable: false,
  width: 100,
  permissions: SUPPLIER_PERMISSIONS.SUPPLIER_WRITE,
  headerName: 'common:actions',
  disablePadding: true,
  renderCell: (_, provider) => <ProviderRowActions provider={provider} />,
};

export const supplierOnlyNameColumn: HeadCell = {
  field: 'name',
  headerName: 'product:fields.name',
  renderCell: (name: string, data: IProvider) => (
    <AvatarNameCell link={`/inventory/provider/suppliers/${data?._id as string}/general`} hideImage name={data.name} />
  ),
};

export const supplierConciliationColumn: HeadCell = {
  field: 'name',
  headerName: 'product:fields.name',
  renderCell: (name: string, data: IProvider) => (
    <AvatarNameCell link={`/conciliations/main/products/${data?._id as string}`} hideImage name={data.name} />
  ),
};

export const supplierStatusColumn: HeadCell<IProvider> = {
  field: 'visible',
  headerName: 'common:fields.visible.title',
  align: CellAlign.CENTER,
  renderCell: (visible: boolean, data: IProvider) => (
    <ProviderStatePicker
      rowId={data._id as string}
      value={visible}
      record={data}
      permissions={SUPPLIER_PERMISSIONS.SUPPLIER_WRITE}
    />
  ),
};

export const conciliationAddressColumn: HeadCell<any> = {
  field: 'address',
  headerName: 'common:address',
  renderCell: (value: IAddress, data: any) => {
    const location = [value?.cityName, value?.stateName, value?.countryName].filter(Boolean).join(', ');
    return <Typography>{location}</Typography>
  },
};

export const supplierColumns: Array<HeadCell<any>> = [
  providerImageColumn,
  supplierOnlyNameColumn,
  providerEmailColumn,
  providerPhoneColumn,
  providerCommissionColumn,
  addressColumn,
  supplierStatusColumn,
  createdATColumn,
  providersActionsColumn,
];

export const supplierConciliationColumns: Array<HeadCell<any>> = [
  providerImageColumn,
  supplierConciliationColumn,
  providerEmailColumn,
  providerPhoneColumn,
  providerCommissionColumn,
  conciliationAddressColumn,
  createdATColumn,
];
